var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClimateChangeSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,16a2.99,2.99,0,0,1,2-2.816V5a1,1,0,0,1,2,0v8.184A2.995,2.995,0,1,1,11,16ZM10,5a4,4,0,0,1,8,0v5.262A7,7,0,0,1,13.984,23a7.177,7.177,0,0,1-.826-.049,7.067,7.067,0,0,1-6.071-5.835A6.986,6.986,0,0,1,10,10.261ZM9.063,16.809a5.038,5.038,0,0,0,4.328,4.155A5,5,0,0,0,19,16a5.013,5.013,0,0,0-2.5-4.325,1,1,0,0,1-.5-.865V5a2,2,0,0,0-4,0v5.81a1,1,0,0,1-.5.865A5,5,0,0,0,9.063,16.809ZM4,5H8A1,1,0,0,0,8,3H4A1,1,0,0,0,4,5ZM9,8A1,1,0,0,0,8,7H6A1,1,0,0,0,6,9H8A1,1,0,0,0,9,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateChangeSvg);
export default __webpack_public_path__ + "static/media/ClimateChangeSvg.3cdd8fda314ac02109d15146df44a0bf.svg";
export { ForwardRef as ReactComponent };